<div class="popup-bg ">
    <div class="popup">
        <div class="popup-content">
            <h3>Edit profile</h3>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div>
            <form [formGroup]="editProfile">
                <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">First Name </span>
                        <input type="text" placeholder="First Name" formControlName="firstName">
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Last Name</span>
                        <input type="text" placeholder="Last Name" formControlName="lastName">
                    </div>
                </div>
                <div class="input-row input-row-wide">
                    <!-- <div class="input-wrap">
                    <span class="input-title">Email ID</span>
                    <input type="text" placeholder="Email Id" formControlName = "email">
                </div> -->
                    <div class="input-wrap">
                        <span class="input-title">DESIGNATION</span>
                        <input type="text" placeholder="Designation" formControlName="designation">
                    </div>
                    <div class="input-wrap">
                        <span class="input-title">Contat Number</span>
                        <div class="input-field">
                            <span class="country-field"><input type="text" formControlName="countryCode"></span>
                            <input type="text" placeholder="Contact Number" formControlName="mobile">
                            
                        </div>
                        <div class="invalid-feedback" *ngIf="(f.mobile.touched && f.mobile.invalid) || (isSubmitted && f.mobile.invalid)" >
                          <span *ngIf="f.mobile.errors.pattern">Please, Enter 10 digit Mobile Number.</span>
                         </div>
                    </div>
                </div>
            </form>
            <a href="javascript:void(0)" class="underline-link" (click)="forPopupOpen('changePassword')">Change
                Password</a>
            <div class="popup-links text-right">
                <a href="javascript:void(0)" class="btn btn-light" (click)="forPopupClose()">Close</a>
                <a href="javascript:void(0)" class="btn btn-dark" (click)="UpdateUserProfile()">Update</a>
            </div>
        </div>
    </div>
</div>